import History from 'app/developer-v3/pages/history';

export default {
  routes: {
    '.': History,
  },
};
